// extracted by mini-css-extract-plugin
export default {"text":"badge_text__WiaEq"};